import { IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDuDieuKienKetQuaHocTapXetTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IDuDieuKienKetQuaHocTapXetTotNghiepReducer";

const iniState : IDuDieuKienKetQuaHocTapXetTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    duDieuKienKetQuaHocTapXetTotNghieps: [],
    selectedIds: [],
}

export const duDieuKienKetQuaHocTapXetTotNghiepReducer = (state: IDuDieuKienKetQuaHocTapXetTotNghiepReducer = iniState, action: IDuDieuKienKetQuaHocTapXetTotNghiepActionTypes): IDuDieuKienKetQuaHocTapXetTotNghiepReducer => {
    switch (action.type) {
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                duDieuKienKetQuaHocTapXetTotNghieps: action.payload,
            };
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_UPDATE_LOCK_STATUS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_UPDATE_LOCK_STATUS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_UPDATE_LOCK_STATUS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_CHANGE_SELECTED_IDS":
            return {
                ...state,
                selectedIds: action.payload,
            };
        default:
            return state;
    }
}